/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coral_Vast_Snake_GrowInputs */

const en_coral_vast_snake_grow = /** @type {(inputs: Coral_Vast_Snake_GrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In Progress`)
};

const de_coral_vast_snake_grow = /** @type {(inputs: Coral_Vast_Snake_GrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In Arbeit`)
};

/**
* | output |
* | --- |
* | "In Progress" |
*
* @param {Coral_Vast_Snake_GrowInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const coral_vast_snake_grow = /** @type {((inputs?: Coral_Vast_Snake_GrowInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coral_Vast_Snake_GrowInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_coral_vast_snake_grow(inputs)
	return de_coral_vast_snake_grow(inputs)
});